export default __webpack_public_path__ + "static/media/Boots of the Eternal Blaze.15b09053.jpg";